import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PlayerHeader from './PlayerHeader';
import PlayerHero from './PlayerHero';
import PlayerTabs from './PlayerTabs';
import PlayerStats from './PlayerStats';
import PlayerCharts from './PlayerCharts';
import PlayerCareer from './PlayerCareer';
import PlayerTeammates from './PlayerTeammates';
import SimilarPlayers from './SimilarPlayers';
import PlayerNeuro from './PlayerNeuro';
import PlayerTrends from './PlayerTrends';
import PlayerTimeline from './PlayerTimeline';
import PlayerTki from './PlayerTki';
const PlayerDetail = () => {
  const {
    playerId
  } = useParams();
  const [activeTab, setActiveTab] = useState('stats');
  return <div className="w-full max-w-7xl mx-auto pb-12 px-4" data-id="element-235" data-mp="yp874qlwgrz1">
      <PlayerHeader data-id="element-236" data-mp="yooo16kijxjf" />
      <div className="mt-4 flex gap-6" data-id="element-237" data-mp="1w4c7eaq4bb12">
        <div className="flex-1" data-id="element-238" data-mp="1w5duxeoblpzo">
          <PlayerHero data-id="element-239" data-mp="1w5neajev0ywe" />
          <PlayerTabs activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-240" data-mp="1rdm2szpinc7f" />
          <div className="mt-4" data-id="element-241" data-mp="1rcawot8llsd5">
            {activeTab === 'stats' && <PlayerStats data-id="element-242" data-mp="1f2c2ephs3tcu" />}
            {activeTab === 'tki' && <PlayerTki data-id="element-243" data-mp="1f4y78hdaburd" />}
            {activeTab === 'neuro' && <PlayerNeuro data-id="element-244" data-mp="1k0naovsfdvsy" />}
            {activeTab === 'charts' && <PlayerCharts data-id="element-245" data-mp="15csgfayrrjdr" />}
            {activeTab === 'trends' && <PlayerTrends data-id="element-246" data-mp="15bzeqoeo3k2h" />}
            {activeTab === 'box_score' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-247" data-mp="1ab3obg5i7jtc">
                Box Score Content
              </div>}
            {activeTab === 'timeline' && <PlayerTimeline data-id="element-248" data-mp="wegrrehgqvny" />}
            {activeTab === 'matches' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-249" data-mp="10f0owi21dza3">
                Matches Content
              </div>}
            {activeTab === 'team_mates' && <PlayerTeammates data-id="element-250" data-mp="rc7ysi4lbtlu" />}
            {activeTab === 'career' && <PlayerCareer data-id="element-251" data-mp="reudd1pwf9dk" />}
          </div>
        </div>
        <div className="w-64" data-id="element-252" data-mp="2gt8ylc1pke4b">
          <SimilarPlayers data-id="element-253" data-mp="2gpuunzdebwur" />
        </div>
      </div>
    </div>;
};
export default PlayerDetail;